import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class KeyboardService {

  private destroy$ = new Subject<void>();

  constructor(private zone: NgZone) {}

  onKey(key: string, callback: () => void, destroyRef: DestroyRef): void {
    this.zone.runOutsideAngular(() => {
      fromEvent<KeyboardEvent>(document, 'keydown')
        .pipe(
          filter(event => event.key === key),
          takeUntilDestroyed(destroyRef)
        )
        .subscribe(() => {
          this.zone.run(() => callback());
        });
    });

    
  }


  
  clear(): void {
    this.destroy$.next();
  }


registerEnterToDelete(
    getItems: () => any[],
    deleteFn: (item: any) => void,
    fallbackFocusSelector: string,
    destroyRef: DestroyRef
  ): void {

    this.zone.runOutsideAngular(() => {

      fromEvent<KeyboardEvent>(document, 'keydown')
        .pipe(
          filter(event => event.key === 'Enter'),
          takeUntilDestroyed(destroyRef)
        )
        .subscribe(event => {

          const active = document.activeElement as HTMLElement | null;
          if (!active) return;

          // 🚫 Do NOT delete if focus is on add-input
          if (active.id === 'add-input') return;

          const row = active.closest('[data-row-index]') as HTMLElement | null;
          if (!row) return;

          event.preventDefault();

          const index = Number(row.getAttribute('data-row-index'));
          const items = getItems();

          if (isNaN(index) || !items[index]) return;

          this.zone.run(() => {

            deleteFn(items[index]);

            setTimeout(() => {

              const rows = document.querySelectorAll('[data-row-index]');

              // ✅ CASE 1: Rows still exist
              if (rows.length > 0) {

                let nextRow: Element | undefined;

                if (rows[index]) {
                  nextRow = rows[index];
                } else if (rows[index - 1]) {
                  nextRow = rows[index - 1];
                }

                if (nextRow) {
                  const target =
                    nextRow.querySelector('input, mat-select') as HTMLElement | null;

                  target?.focus();
                }
              }

              // ✅ CASE 2: No rows left
              else {
                const fallback =
                  document.querySelector(fallbackFocusSelector) as HTMLElement | null;

                fallback?.focus();
              }

            });

          });

        });

    });
  }


// registerArrowNavigation(container: HTMLElement): void {

//   this.zone.runOutsideAngular(() => {

//     fromEvent<KeyboardEvent>(container, 'keydown')
//       .pipe(
//         filter(event =>
//           ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown']
//             .includes(event.key)
//         ),
//         takeUntil(this.destroy$)
//       )
//       .subscribe(event => {

//         const active = document.activeElement as HTMLElement | null;
//         if (!active) return;

//         if (!['INPUT', 'BUTTON', 'TEXTAREA']
//             .includes(active.tagName)) {
//           return;
//         }

//         // ======================================
//         // SMART LEFT / RIGHT (cursor safe)
//         // ======================================

//         if (active.tagName === 'INPUT') {
//           const input = active as HTMLInputElement;

//           const atStart = input.selectionStart === 0;
//           const atEnd = input.selectionStart === input.value.length;

//           if (event.key === 'ArrowLeft' && !atStart) return;
//           if (event.key === 'ArrowRight' && !atEnd) return;
//         }

//         // ======================================
//         // COLUMN-BASED UP / DOWN
//         // ======================================

//       // ======================================
// // COLUMN-BASED UP / DOWN (FULL FIX)
// // ======================================

// if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {

//   const currentRow = active.closest('[data-row-index]') as HTMLElement | null;
//   if (!currentRow) return;

//   const rows = Array.from(
//     container.querySelectorAll<HTMLElement>('[data-row-index]')
//   );

//   const rowIndex = rows.indexOf(currentRow);
//   if (rowIndex === -1) return;

//   const direction = event.key === 'ArrowDown' ? 1 : -1;
//   const targetRow = rows[rowIndex + direction];
//   if (!targetRow) return;

//   const getFocusable = (row: HTMLElement) =>
//     Array.from(
//       row.querySelectorAll<HTMLElement>('input, button')
//     ).filter(el =>
//       !el.hasAttribute('disabled') &&
//       el.offsetParent !== null
//     );

//   const currentRowElements = getFocusable(currentRow);
//   const columnIndex = currentRowElements.indexOf(active);
//   if (columnIndex === -1) return;

//   const targetRowElements = getFocusable(targetRow);
//   if (targetRowElements.length === 0) return;

//   // ✅ Try exact column first
//   let targetElement = targetRowElements[columnIndex];

//   // ✅ If not available (like + vs delete mismatch)
//   if (!targetElement) {
//     // fallback to last element
//     targetElement = targetRowElements[targetRowElements.length - 1];
//   }

//   event.preventDefault();
//   targetElement.focus();
//   return;
// }

//         // ======================================
//         // GLOBAL LEFT / RIGHT FLOW
//         // ======================================

//         const focusable = Array.from(
//           container.querySelectorAll<HTMLElement>(
//             'input, button, textarea'
//           )
//         ).filter(el =>
//           !el.hasAttribute('disabled') &&
//           el.offsetParent !== null
//         );

//         const index = focusable.indexOf(active);
//         if (index === -1) return;

//         event.preventDefault();

//         if (event.key === 'ArrowRight' && focusable[index + 1]) {
//           focusable[index + 1].focus();
//         }

//         if (event.key === 'ArrowLeft' && focusable[index - 1]) {
//           focusable[index - 1].focus();
//         }

//       });

//   });
// }
registerGlobalDoubleEnter(callback: () => void, destroyRef: DestroyRef): void {

  let lastEnterTime = 0;
  const delay = 400; // ms

  this.zone.runOutsideAngular(() => {

    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter(event => event.key === 'Enter'),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe(event => {

        const active = document.activeElement as HTMLElement | null;
        if (!active) return;

        // 🚫 Ignore textarea
        if (active.tagName === 'TEXTAREA') return;

        const now = Date.now();

        if (now - lastEnterTime < delay) {
          this.zone.run(() => callback());
        }

        lastEnterTime = now;
      });

  });
}
}
